import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { Region } from "../../types";

interface ActiveRegionCardProps {
  imageSrc: string;
  region: Region;
}

export const ActiveRegionCard = ({
  imageSrc,
  region,
}: ActiveRegionCardProps) => {
  const { t } = useTranslation();

  if (!region.width || !region.height) return null;

  const scaleX = 100 / region.width;
  const scaleY = 100 / region.height;
  const offsetX = -region.x * scaleX;
  const offsetY = -region.y * scaleY;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "10px 14px",
          borderBottom: `1px solid ${region.color}22`,
        }}
      >
        <FiberManualRecordIcon sx={{ fontSize: 8, color: region.color }} />
        <Typography
          sx={{
            fontFamily: 'var(--font-family, "AktivGrotesk")',
            fontWeight: 500,
            fontSize: "var(--body-b3-12-regular-size, 12px)",
            color: "var(--alias-text-on-white-primary, #000)",
          }}
        >
          {region.label} —{" "}
          {t("ldp_explore_image_results_active_region", "active region")}
        </Typography>
      </Box>
      <Box
        sx={{
          height: 120,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src={imageSrc}
          alt={region.label}
          style={{
            position: "absolute",
            width: `${scaleX * 100}%`,
            height: `${scaleY * 100}%`,
            left: `${offsetX}%`,
            top: `${offsetY}%`,
            objectFit: "fill",
          }}
        />
      </Box>
    </Box>
  );
};
